import React from 'react'
import { predictionHTML } from './predictionHelper'
import { Desc, Head2 } from '../../Typography/Text.styles'

export const PredictionTable: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div className="predictionsCon">
      <div className="titleCon">
        <Head2>Playoff Probabilities</Head2>
      </div>
      <Desc>
        Predictions for the Postseason and Championship Series • Updated Mondays
      </Desc>
      <div
        className="predictionTable"
        dangerouslySetInnerHTML={{
          __html: predictionHTML,
        }}
      />
    </div>
  )
}
